module.exports = __webpack_public_path__ + "static/media/who_made_the_call.70d83f98.png";